export const memberGroupTypes = {
  Student: 'Student',
  FacultyStaff: 'Higher Ed F&S',
  K12FacultyStaff: 'K-12 F&S',
}
